export const monthsToYears = (valueInMonths: number ) => {
  const MONTHS_OF_AN_YEAR = 12;
  if (valueInMonths % MONTHS_OF_AN_YEAR === 0) {
    return valueInMonths / MONTHS_OF_AN_YEAR;
  }
  return undefined;
};
